import { autoinject } from "aurelia-dependency-injection";
import { EventAggregator } from "aurelia-event-aggregator";
import { UserManager } from "oidc-client";
import { FetchClient } from "../common/fetch-client";
import { OidcSignOut } from "../common/oidc/oidc-event-handler";
import config from "../common/config";
import { MessageService } from "./message-service";
import { ISetUserProfile } from "../resources-vue/vue-interfaces/messaging-service/i-user";
import { ProfileActivityStatusEnum, ProfileStatusEnum } from "../enums/ChatUserProfileEnum";
import { useApp } from "../pages-vue/App/useApp";

export const accountIdKey = "hospice-account-id";
export const lineOfService = "hospice-line-of-service";

export const enum AccountEvent {
    Selected = "account:selected",
    ProvidersSelected = "account:providersSelected"
}
@autoinject()
export default class AuthService {
    private _fetchClient: FetchClient;
    private _ea: EventAggregator;
    private _userManager: UserManager;
    public _messageService: MessageService;
    private user: any;

    public constructor(
        ea: EventAggregator,
        fetchClient: FetchClient,
        userManager: UserManager,
        messageService: MessageService
    ) {
        this._ea = ea;
        this._fetchClient = fetchClient;
        this._userManager = userManager;
        this._messageService = messageService;
    }

    public async isLoggedIn(): Promise<boolean> {
        this.user = await this._userManager.getUser();
        return this.user != null && !this.user.expired;
    }

    public async logout(): Promise<void> {
        window.localStorage.removeItem(config.organizationId);
        window.localStorage.removeItem(config.organizationName);
        window.sessionStorage.removeItem("draftConversations");
        window.sessionStorage.removeItem("draftMessages");
        window.localStorage.removeItem("axxess-nps-survey-2026-shown");
        const appStore = useApp();
        if (appStore.isAnyPremiumAgency && appStore.hasAxxessConnectPermission) {
            const payload: ISetUserProfile = {
                login: this.user.profile.sub,
                status: ProfileStatusEnum.Available,
                userActivityStatus: ProfileActivityStatusEnum.Logout
            };
            await this._messageService.updateUserProfile(payload);
        }
        this._ea.publish(OidcSignOut);
    }

    public getAccountId() {
        let cachedAccountData = window.localStorage.getItem(accountIdKey);
        return cachedAccountData;
    }

    public getLineOfService() {
        return Number(window.localStorage.getItem(lineOfService));
    }

    public needsAccountSelection() {
        return this.getAccountId() == null;
    }
}
